module.exports = __webpack_public_path__ + "media/bootstrap-icons/youtube-dff66ab9.svg";